<template>
  <div style="width: 100%; height: 100%">
    <div v-if="!LoadPage" class="login" style="width: 100%; height: 100%">
      <el-image
        v-if="setting.logo"
        style="cursor: pointer; position: absolute; top: 4%; left: 15%; z-index: 2; width: 200px; display: block"
        :src="setting.logo"
        @click="handlerChangePage"
      ></el-image>
      <div
        class="content"
        v-if="setting"
        :style="setting.homeBackImg ? 'background-image: url(' + setting.homeBackImg + ');' : ''"
      >
        <div
          style="
            width: 850px;
            display: flex;
            border-radius: 6px;
            -webkit-box-shadow: rgb(0 0 0 / 20%) -1px -1px 25px;
            -moz-box-shadow: rgb(0 0 0 / 20%) -1px -1px 25px;
            box-shadow: rgb(0 0 0 / 20%) -1px -1px 25px;
          "
        >
          <div
            v-if="setting.homeSignImg"
            style="
              width: 470px;
              background-color: white;
              border-radius: 6px 10px 10px 6px;
              padding: 24px 0 36px 36px;
              border-right: 1px solid #ccc;
            "
            :style="`background:url('${setting.homeSignImg}') center/cover`"
          ></div>
          <div
            v-else
            style="
              width: 470px;
              background-color: white;
              border-radius: 6px 10px 10px 6px;
              padding: 24px 0 36px 36px;
              border-right: 1px solid #ccc;
            "
          >
            <div class="login-showcase">
              <div class="showcase-copy">
                <div class="showcase-brand">ReyVend</div>
                <div class="showcase-title">{{ $t("login.consoleTitle") }}</div>
                <div class="showcase-desc">{{ $t("login.consoleDesc") }}</div>
                <div class="showcase-points">
                  <div class="showcase-point">
                    {{ $t("login.consoleFeature1") }}
                  </div>
                  <div class="showcase-point">
                    {{ $t("login.consoleFeature2") }}
                  </div>
                  <div class="showcase-point">
                    {{ $t("login.consoleFeature3") }}
                  </div>
                </div>
              </div>
            </div>

            <div class="showcase-downloads">
              <!-- 苹果下载 -->
              <el-tooltip class="item" effect="dark" placement="bottom">
                <div
                  @click="handlerDownLoad(1)"
                  class="download-card"
                >
                  <img src="../assets/img/ios.png" class="download-card__icon" />
                  <div class="download-card__text">
                    <div class="download-card__title">{{ $t("login.iosApp") }}</div>
                    <div class="download-card__caption">
                      {{ $t("login.downloadCaption") }}
                    </div>
                  </div>
                </div>
                <template #content>
                  <img src="../assets/img/appstore_url.png" alt="" style="width: 150px; height: 150px" />
                </template>
              </el-tooltip>
              <!-- 谷歌下载 -->
              <!-- <el-tooltip class="item" effect="dark" placement="bottom">
                <div
                  @click="handlerDownLoad(4)"
                  style="
                    width: 128px;
                    height: 48px;
                    margin-left: 17px;
                    background-color: #321108;
                    cursor: pointer;
                    border-radius: 4px;
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <img src="../assets/img/google.png" style="width: 28px; height: 28px; display: block" />
                  <div style="margin-left: 5px; line-height: 18px; font-size: 14px; font-weight: bold">
                    <div>Google Play</div>
                    <div style="font-weight: normal">
                      {{ $t("login.downLoad") }}
                    </div>
                  </div>
                </div>
                <template #content>
                  <img
                    src="https://oss.reyeah.com/reyeah/20231127/1701071822206-194ab43c-cc65-476d-a16e-25d467a57c93.png"
                    alt=""
                    style="width: 150px; height: 150px"
                  />
                </template>
              </el-tooltip> -->
              <!-- 在线下载 -->
              <el-tooltip class="item" effect="dark" placement="bottom">
                <div
                  @click="handlerDownLoad(2)"
                  class="download-card download-card--android"
                >
                  <img src="../assets/img/android.png" class="download-card__icon" />
                  <div class="download-card__text">
                    <div class="download-card__title">{{ $t("login.androidApp") }}</div>
                    <div class="download-card__caption">{{ $t("login.downloadCaption") }}</div>
                  </div>
                </div>
                <template #content>
                  <img src="../assets/img/android_url.png" alt="" style="width: 150px; height: 150px" />
                </template>
              </el-tooltip>
            </div>
            <!-- <div style="color: #321108; font-size: 15px; margin: 15px 0; width: 90%; line-height: 1.2" class="font_14">
              {{ $t("login.loginTip3") }}
            </div>
            <div
              style="
                padding: 10px 0;
                width: 280px;
                background-color: #fbb03b;
                cursor: pointer;
                border-radius: 4px;
                color: white;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <img src="../assets/img/net.png" style="width: 24px; height: 24px; display: block" />
              <el-tooltip class="item" effect="dark" placement="bottom">
                <div
                  @click="handlerDownLoad(3)"
                  style="
                    margin: 0 10px;
                    width: 180px;
                    font-weight: bold;
                    line-height: 26px;
                    font-size: 14px;
                    text-align: center;
                  "
                >
                  {{ $t("login.h5url") }}
                </div>
                <template #content>
                  <img :src="appInfo.h5QrCode" alt="" style="width: 150px; height: 150px" />
                </template>
              </el-tooltip>

              <img
                @click.stop="handlerCopy"
                src="../assets/img/copy.png"
                style="width: 24px; height: 24px; display: block"
              />
            </div> -->
          </div>
          <div style="width: 350px; background-color: white; border-radius: 10px; overflow: hidden">
            <el-form
              :label-position="labelPosition"
              class="login-container"
              :rules="rules"
              ref="login"
              label-width="80px"
              :model="login"
            >
              <el-image
                v-if="setting.logo"
                class="logo"
                :src="setting.logo"
                fit="fill"
                style="margin-bottom: 6%"
              ></el-image>
              <div class="login-top">
                <div class="title">{{ $t("login.login") }}</div>
                <div class="lang">
                  <el-dropdown trigger="hover" @command="commandLanguage">
                    <span class="el-dropdown-link" style="cursor: pointer; font-size: 14px; color: #606266">
                      {{ language }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="zh_CN" :disabled="$i18n.locale === 'zh_CN'"
                        >简体中文</el-dropdown-item
                      >
                      <el-dropdown-item command="en_US" :disabled="$i18n.locale === 'en_US'"
                        >English</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <div class="login-main" v-if="type === 0">
                <el-form-item :prop="type === 0 ? 'account' : ''">
                  <el-input
                    v-model="login.account"
                    :placeholder="$t('login.userName')"
                    @input="login.account = login.account.toLowerCase()"
                    prefix-icon="el-icon-message"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item :prop="type === 0 ? 'password' : ''">
                  <el-input
                    v-model="login.password"
                    type="password"
                    :placeholder="$t('login.password')"
                    auto-complete="off"
                    prefix-icon="el-icon-lock"
                    show-password
                  ></el-input>
                </el-form-item>
                <el-form-item :prop="type === 0 ? 'code' : ''" v-if="failNum > 2">
                  <el-input
                    v-model="login.code"
                    style="width: calc(100% - 142px)"
                    prefix-icon="iconfont icon-anquan"
                    :placeholder="$t('login.code')"
                  ></el-input>
                  <div
                    class="login-code"
                    @click="getLoginCode()"
                    style="
                      border: 1px solid #dcdfe6;
                      width: 130px;
                      height: 43px;
                      float: right;
                      border-radius: 4px;
                      overflow: hidden;
                    "
                  >
                    <img :src="codeImage" />
                  </div>
                </el-form-item>
                <div class="operation">
                  <div>
                    <el-checkbox v-model="login.checked">
                      <el-tooltip class="item" effect="dark" :content="$t('login.checked')" placement="right">
                        <span>{{ $t("login.remember") }}</span>
                      </el-tooltip>
                    </el-checkbox>
                  </div>
                  <div class="forget" @click="forget(1)">
                    {{ $t("login.forgotPassword") }}
                  </div>
                </div>
                <el-button
                  type="primary"
                  style="width: 100%; margin-top: 20px"
                  @click="submitForm('login')"
                  :loading="loading"
                >
                  {{ loading ? $t("login.logging") : $t("login.login") }}
                </el-button>
              </div>
              <div class="forgot" v-if="type === 1">
                <el-form-item :prop="type === 1 ? 'emailManger' : ''" :error="emailManger">
                  <el-input
                    v-model="login.emailManger"
                    :placeholder="$t('login.emailManger')"
                    prefix-icon="el-icon-message"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item :prop="type === 1 ? 'captcha' : ''">
                  <el-input
                    v-model="login.captcha"
                    :placeholder="$t('login.verify')"
                    prefix-icon="iconfont icon-anquan"
                    auto-complete="off"
                  >
                  </el-input>
                  <span class="captcha" @click="captcha">{{ $t("login.captchaText") }}</span>
                </el-form-item>
                <el-form-item :prop="type === 1 ? 'newPassword' : ''">
                  <el-input
                    v-model="login.newPassword"
                    :placeholder="$t('login.newPassword')"
                    prefix-icon="el-icon-lock"
                    show-password
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
                <div class="operation">
                  <div class="forget" @click="forget(0)">
                    {{ $t("login.backLogin") }}
                  </div>
                </div>
                <el-button
                  type="primary"
                  style="width: 100%; margin-top: 20px"
                  @click="submitForgot('login')"
                  :loading="loading"
                >
                  {{ loading ? $t("login.modifying") : $t("login.updatePassword") }}
                </el-button>
              </div>
            </el-form>
          </div>
        </div>
        <div v-if="setting.homeDownText" class="bottom">
          <el-image
            v-if="setting.homeDownImg"
            class="logo"
            :src="setting.homeDownImg"
            fit="fill"
            style="margin: 0; margin-bottom: 20px; margin-right: 10px"
          ></el-image>
          <div v-html="setting.homeDownText"></div>
          <!-- <el-dropdown
						@command="handleCommand"
						style="margin: 0 0 0.1rem 10px; font-size: 16px">
						<span class="el-dropdown-link" style="color: #000">
							{{ $t("login.ysxy") }}
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="1"
								>DataIT Security Policy</el-dropdown-item
							>
							<el-dropdown-item command="2"
								>Vending Machine Data Privacy Policy</el-dropdown-item
							>
							<el-dropdown-item command="3"
								>Vending Machine Service Terms of Use</el-dropdown-item
							>
						</el-dropdown-menu>
					</el-dropdown> -->
        </div>
      </div>
    </div>
    <div
      v-else
      style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; text-align: center"
    >
      <div v-loading="true"></div>
    </div>
  </div>
</template>

<script>
  import language from "../utils/language";
  import config from "@/http/config";
  const md5 = require("js-md5");
  export default {
    name: "Login",
    data() {
      const account = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("login.userName")));
        } else {
          callback();
        }
      };
      const password = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("login.password")));
        } else {
          callback();
        }
      };
      const code = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("login.verify")));
        } else {
          callback();
        }
      };
      const emailManger = (rule, value, callback) => {
        if (value === "") {
          this.verify = false;
          callback(new Error(this.$t("login.userName")));
        } else {
          let reg = new RegExp("^[a-z0-9A-Z]+[- |a-z0-9A-Z._]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$");
          if (!reg.test(value)) {
            this.verify = false;
            callback(new Error(this.$t("login.emailError")));
          } else {
            this.verify = true;
            callback();
          }
        }
      };
      const captcha = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("login.verify")));
        } else {
          callback();
        }
      };
      const newPassword = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("login.password")));
        } else {
          callback();
        }
      };
      return {
        appInfo: {
          androidDownUrl: "",
          androidQrCode: "",
          androidVersion: "",
          h5DownUrl: "",
          h5QrCode: "",
          h5Version: "",
          iosDownUrl: "",
          iosQrCode: "",
          iosVersion: ""
        },
        LoadPage: true,
        uploadUrl: config.baseUrl + this.$url.IDard.jzupload,
        headers: {
          appId: "123456789"
        },
        zmURL: "",
        fmURL: "",
        localtype: "",
        equipmentNo: "",
        age: 0,
        ischengnian: 3,
        labelPosition: "top",
        loading: false,
        login: {
          account: "",
          password: "",
          code: "",
          checked: false,
          codeKey: "",
          emailManger: "",
          captcha: "",
          newPassword: ""
        },
        codeImage: "",
        verify: false,
        passVal: "",
        failNum: 0,
        type: 0,
        rules: {
          account: [{ required: true, validator: account, trigger: "blur" }],
          password: [{ required: true, validator: password, trigger: "blur" }],
          code: [{ required: true, validator: code, trigger: "blur" }],
          emailManger: [{ required: true, validator: emailManger, trigger: "blur" }],
          captcha: [{ required: true, validator: captcha, trigger: "blur" }],
          newPassword: [{ required: true, validator: newPassword, trigger: "blur" }]
        },
        language: "",
        emailManger: "",
        port: "",
        setting: {},
        loginCountry: "",
        txMapKey: ""
      };
    },
    mounted() {
      let _self = this;
      let uId = "";
      if (this.$route.query.uId) {
        uId = this.$route.query.uId;
      } else {
        uId = 1;
      }
      // loginuserId 用于服务端，存 sessionStorage
      sessionStorage.setItem("loginuserId", uId);
      let that = this;
      // init language
      this.lang();
      this.port = window.location.host.split(":")[1];
      // 获取记住的密码
      let Account = localStorage.getItem("Account");
      if (Account) {
        Account = JSON.parse(Account);
        that.login.checked = true;
        that.login.account = Account.account;
        that.login.password = this.$tools.Decrypt(Account.password);
      }
      let hostname = window.location.hostname;
      let firstDotIndex = hostname.indexOf(".");
      let prefix = hostname.substring(0, firstDotIndex);

      //  获取配置信息
      let url = this.$url.Promote.getDefault;
      let method = this.$method.get;
      this.$api
        .request(url, method, {
          key: "LOGO",
          uId,
          loginLocale: prefix || "custom"
          // loginLocale: "custom",
        })
        .then(res => {
          if (res.code === 0) {
            this.setting = res.data.logo;
            this.appInfo = res.data.app || {};
            let icon = res.data.logo.icon;

            this.setFavicon(icon);
            let djs = setTimeout(function () {
              clearTimeout(djs);
              _self.LoadPage = false;
            }, 1000);
          }
        })
        .catch(err => {
          this.$notify({
            title: this.$t("common.tip"),
            message: err.msg,
            type: "error"
          });
        });
    },
    methods: {
      // 动态设置网站icon
      setFavicon(iconUrl) {
        let link = document.querySelector("link[rel*='icon']") || document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = iconUrl;
        document.getElementsByTagName("head")[0].appendChild(link);
      },
      handlerCopy() {
        this.$tools.copy(this.appInfo.h5DownUrl || "");
      },
      handlerDownLoad(n) {
        switch (+n) {
          case 1:
            // 点击ios按钮
            window.open("https://apps.apple.com/us/app/reyvend/id6755369409", "_blank");
            break;
          case 2:
            // 在线下载
            window.open("https://foreign-custom.s3.us-east-2.amazonaws.com/noDelete/apk/vending.apk", "_blank");
            break;
          case 3:
            // 点击h5按钮
            // if (this.appInfo.h5DownUrl) window.open(this.appInfo.h5DownUrl, "_blank");
            break;
          case 4:
            // 点击google按钮
            // window.open("", "_blank");
            break;
        }
      },
      lang() {
        const storeLang = this.$store.getters.lang;
        const fallbackLang = "en_US";
        const currentLang = language[storeLang] ? storeLang : fallbackLang;

        this.language = (language[currentLang] && language[currentLang]["1"]) || currentLang;
        this.$i18n.locale = currentLang;
        this.$store.dispatch("setLang", currentLang);
      },
      commandLanguage(command) {
        const nextLang = language[command] ? command : "en_US";
        this.language = (language[nextLang] && language[nextLang]["1"]) || nextLang;
        this.$i18n.locale = nextLang;
        this.$store.dispatch("setLang", nextLang);
      },
      submitForm(formName) {
        const that = this;
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.loading = true;
            const obj = {
              userName: that.login.account,
              passWord: md5(that.login.password),
              lang: this.$store.getters.lang
            };
            obj.code = that.login.code;
            obj.codeKey = that.login.codeKey;
            obj.checked = that.login.checked;
            that.$api
              .request(that.$url.Login.login, that.$method.post, that.$qs.stringify(obj))
              .then(res => {
                if (res.code === 0) {
                  if (res.data !== "") {
                    let userInfo = res.data;
                    localStorage.setItem("pId", userInfo.pid);
                    localStorage.setItem("uId", userInfo.uid);
                    localStorage.setItem("userName", userInfo.userName);
                    localStorage.setItem("warehouseAccount", that.login.account);
                    sessionStorage.setItem("localuserid", userInfo.uid);
                    if (that.login.checked) {
                      localStorage.setItem(
                        "Account",
                        JSON.stringify({
                          account: that.login.account,
                          password: that.$tools.Encrypt(that.login.password)
                        })
                      );
                    } else {
                      localStorage.removeItem("Account");
                    }
                    sessionStorage.setItem("parentId", userInfo.pid);
                    that.$store.dispatch("setParentId", userInfo.pid);
                    userInfo.checked = that.login.checked;
                    userInfo.token = res.data.token;
                    that.$store.dispatch("login", userInfo).then(() => {
                      that.$router.push("/main?showAgreePrivacy=" + userInfo.agreement);
                    });
                  }
                } else {
                  that.failNum++;
                  if (that.failNum > 2) {
                    that.getLoginCode();
                  }
                }
                that.loading = false;
              })
              .catch(() => {
                that.loading = false;
              });
          } else {
            return false;
          }
        });
      },
      // 找回密码
      submitForgot(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.loading = !this.loading;
            let obj = {
              userName: this.login.emailManger,
              passWord: md5(this.login.newPassword),
              emailCode: this.login.captcha
            };
            this.$api
              .request(this.$url.User.findPassword, this.$method.post, obj)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(res.msg);
                } else {
                  this.$message.error(res.msg);
                }
                this.loading = false;
              })
              .catch(() => {
                this.$message.error(this.$t("login.updatePasswordError"));
                this.loading = false;
              });
          }
        });
      },
      //   icon点击跳转
      handlerChangePage() {
        if (!this.setting.logoUrl) return;
        location.href = this.setting.logoUrl;
      },
      // 登录验证码
      getLoginCode() {
        this.$api.request(this.$url.Login.captcha, this.$method.get).then(res => {
          if (res.code === 0) {
            this.codeImage = res.data.code;
            this.login.codeKey = res.data.key;
          }
        });
      },
      // 切换登录或忘了密码
      forget(val) {
        this.type = val;
        this.$refs.login.clearValidate();
      },
      // 隐私协议
      handleCommand(command) {
        this.$message("click on item " + command);
        window.open("http://securitypolicy.reyeah.com?type=" + command);
      },
      // 忘记密码手机验证码
      captcha() {
        if (this.verify) {
          if (this.login.emailManger === "") {
            this.emailManger = this.$t("login.emailManger");
          } else {
            this.$api
              .request(this.$url.User.verifyUser, this.$method.post, {
                userName: this.login.emailManger
              })
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(res.msg);
                } else {
                  this.$message.warning(res.msg);
                }
              });
          }
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .login {
    height: 100%;

    .content {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: var(--vtm-brand-gradient);
      background-size: cover;
      position: relative;
      .logo {
        width: 130px;
        display: block;
        margin: 0 auto;
        margin-bottom: 20px;
      }
      .ad-bg {
        width: 960px;
        height: 640px;
        position: absolute;
        left: 15%;
        top: 18%;
      }
      .login-container {
        text-align: center;
        width: 88%;
        border-radius: 0px 6px 6px 0px;
        padding: 7% 6%;
        background-color: #fff;

        .login-top {
          overflow: hidden;
          margin-bottom: 10px;
          .title {
            font-size: 20px;
            box-sizing: border-box;
            color: #707070;
            text-align: left;
            letter-spacing: 2px;
          }
          div {
            float: left;
          }
          .lang {
            float: right;
            margin-top: 8px;
          }
        }
      }

      .login-showcase {
        width: calc(100% - 36px);
      }

      .showcase-copy {
        margin-right: 36px;
      }

      .showcase-brand {
        display: inline-flex;
        align-items: center;
        padding: 6px 12px;
        border-radius: 8px;
        background: #edf5f1;
        color: #1c5a44;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 2px;
      }

      .showcase-title {
        margin-top: 14px;
        font-size: 32px;
        line-height: 1.2;
        color: #11352e;
        font-weight: 700;
      }

      .showcase-desc {
        margin-top: 12px;
        color: #4c5f58;
        font-size: 15px;
        line-height: 1.7;
      }

      .showcase-points {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 16px;
      }

      .showcase-point {
        padding: 7px 12px;
        border-radius: 8px;
        border: 1px solid #d7e3dc;
        background: #ffffff;
        color: #315247;
        font-size: 13px;
        line-height: 1;
      }

      .showcase-downloads {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-top: 24px;
        width: calc(100% - 36px);
      }

      .download-card {
        flex: 1;
        height: 56px;
        padding: 0 18px;
        border-radius: 10px;
        border: 1px solid #163e2d;
        background: #163e2d;
        color: white;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .download-card--android {
        border-color: #1f5a41;
        background: #1f5a41;
      }

      .download-card__icon {
        width: 28px;
        height: 28px;
        display: block;
      }

      .download-card__text {
        margin-left: 8px;
        line-height: 1.1;
      }

      .download-card__title {
        font-size: 15px;
        font-weight: 700;
      }

      .download-card__caption {
        margin-top: 4px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.84);
      }
    }
    .el-input__icon {
      margin-left: 5px;
      font-size: 22px !important;
    }
    .el-input__inner {
      padding-left: 36px;
      height: 45px;
      line-height: 45px;
      font-size: 14px;
    }
    .el-input__icon {
      line-height: 45px !important;
    }
    .login-code {
      cursor: pointer;
    }

    .bottom {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      font-size: 16px;

      div {
        margin-bottom: 10px;
      }

      div:last-child {
        margin-bottom: 0;
      }
    }

    .operation {
      div {
        float: left;
      }

      .forget {
        float: right;
        color: #606266;
        cursor: pointer;
      }

      .forget:hover {
        color: #409eff;
      }
    }

    .forgot {
      .captcha {
        position: absolute;
        right: 2px;
        top: 2px;
        border-radius: 3px;
        padding: 0 10px;
        background: rgba(0, 0, 0, 0.5);
        color: rgba(255, 255, 255, 0.8);
        cursor: pointer;
      }
    }
  }
</style>
